function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.36,7.24c-1.49,1.49-1.78,3.83-.91,6.69A18.13,18.13,0,0,0,11,21a18.09,18.09,0,0,0,7,4.51c2.75.93,5.15.57,6.69-.91h0l1-1.09a1.24,1.24,0,0,0,0-1.67l-3.44-3.43a1.24,1.24,0,0,0-1.67,0l-1.09,1c-.47.47-2.69,1-5.32-1.67S12,12.94,12.5,12.42l1.11-1a1.22,1.22,0,0,0,0-1.67L10.29,6.33a1.22,1.22,0,0,0-1.67,0C8.47,6.16,7.36,7.24,7.36,7.24Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallWhite);
export default __webpack_public_path__ + "static/media/call-white.67f96d6a.svg";
export { ForwardRef as ReactComponent };